import { Trans, useTranslation } from "react-i18next";
// Interfaces
import { IPost } from "@/i18n/json/blog/interfaces";
// Tailwind classes
import {
  actionContainer,
  button,
  buttonText,
  image,
  imageWrapper,
  line,
  summary,
  timeStamp,
  title,
  wrapper,
} from "./styles/blog-item";
import Arrow from "@/components/arrow";
import CustomLink from "../custom-link";
import { LazyLoadImage } from "react-lazy-load-image-component";
import classNames from "classnames";

interface IBlogItem extends IPost {
  arrows?: React.ReactElement | null;
  collection?: "all" | "latest";
}

const BlogItemAlt: React.FC<IBlogItem> = ({
  id,
  date,
  permalink,
  collection = "latest",
}) => {
  const { t } = useTranslation();
  return (
    <a href={permalink}>
      <div className={wrapper}>
        <div className={imageWrapper}>
          <LazyLoadImage
            className={classNames(image, "object-cover !w-full !h-full")}
            sizes="(max-width:736px) 420px, 800px"
            src={`/assets/images/blog/${id}/thumb.jpg`}
            alt={t(`blog.${collection}.${id}.title`).replace(
              /<[^>]*>\s|<[^>]*>/g,
              " "
            )}
          />
        </div>
        <div>
          <p className={title}>
            <Trans components={{ sup: <sup />, span: <span style={{}} /> }}>
              blog.{collection}.{id}.title
            </Trans>
          </p>
          <hr className={line} />
          <p className={summary}>
            <Trans components={{ sup: <sup /> }}>
              blog.{collection}.{id}.summary
            </Trans>
          </p>
        </div>
        <div className={actionContainer}>
          <p className="text-[#04A9F4] font-bold">{date}</p>
        </div>
      </div>
    </a>
  );
};

export default BlogItemAlt;
